import React, {FC, useContext, useEffect} from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { connect } from 'react-redux';

import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from "@mui/material/Button";

import { FormPhoneInput } from 'components/FormInput';
import { ReactComponent as DeleteInput } from 'assets/images/icon_delete_input.svg';
import { actionCreators } from 'store/Cashiers'
import { CashierContext, Steps } from 'contexts/CashierContext';
import { SendCodeRequest } from 'api/models';
import { removeSpacesFormString } from 'shared/functions';
import { ApplicationState } from 'store';
import analytics from 'services/analytics';
import { AnalyticsEvents } from 'shared/constants/analytics';

type FormValues = {
  phoneNumber: string;
};

interface ReduxProps {
  getCashierCode: (data: SendCodeRequest, callBack: () => void) => void,
  removeErrors: () => void,
  phoneNumberError: string
}

const PhoneNumber: FC<ReduxProps> = props => {
  const { setStep, onCloseModal } = useContext(CashierContext);
  const methods = useForm<FormValues>({
    mode: 'onChange'
  });

  useEffect(() => {
    if (props.phoneNumberError) {
      methods.setError('phoneNumber', { message: props.phoneNumberError })
    }
    props.removeErrors();
  }, [props.phoneNumberError]);

  const onSubmit = (data: FormValues) => {
    props.getCashierCode(
      { phone: removeSpacesFormString(data.phoneNumber) },
      () => setStep(Steps.verificationCode));
    analytics().sendEvent(AnalyticsEvents.cashiers_cashier_edit_phone_verification_send_phone);
  };

  const clearValue = () => {
    methods.setValue('phoneNumber', '+380');
    methods.clearErrors();
  };

  return (
    <>
      <DialogContent dividers>
        <FormProvider {...methods}>
          <Typography
            ml={2}
            mb={.5}
            color={({ colors }) => colors.secondaryGrey}
            fontSize='0.8571428571428571rem'>
            МОБІЛЬНИЙ НОМЕР ТЕЛЕФОНУ:
          </Typography>
          <FormPhoneInput
            fullWidth
            name='phoneNumber'
            InputProps={{
              endAdornment: <DeleteInput style={{ cursor: 'pointer' }} onClick={clearValue} />
            }}
            autoFocus={true}
          />
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          onCloseModal();
          analytics().sendEvent(AnalyticsEvents.cashiers_cashier_edit_phone_verification_send_phone_cancel);
        }} size='large' variant='contained' color='inherit'>Відмінити</Button>
        <Button
          size='large'
          onClick={methods.handleSubmit(onSubmit)}
          disabled={
            !methods.getValues('phoneNumber') ||
            methods.getValues('phoneNumber') === '+380' ||
            !!Object.keys(methods.formState.errors).length
          }
        >
          Продовжити
        </Button>
      </DialogActions>
    </>
  );
};

const mapStateToProps = (state: ApplicationState) => ({
  phoneNumberError: state.cashiers.errors.phoneNumber
})

const mapDispatchToProps = {
  getCashierCode: actionCreators.getCashierCode,
  removeErrors: actionCreators.removeErrors,
};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneNumber);
